import {FormModel} from "./form.model.abstract";

/**
 * Shows several fields inside onw wrapper.
 * @inheritDoc
 */
export class FormModelCombine extends FormModel {

  /**
   * @inheritDoc
   */
  public type = 'combine';

  /**
   * List of ids in this combined field.
   * @private
   */
  private ids: string[] = [];

  /**
   * @inheritDoc
   * @param id
   * @param fields List of fields that are combined
   * @param info
   */
  constructor(id: string, fields: FormModel[], info: boolean = false) {
    super(id, [], null, null, info);

    this.fieldData["fields"] = fields;
    for(const field of fields) {
      this.ids.push(field.id);
      if(field.fieldData?.secondId) {
        this.ids.push(field.fieldData.secondId);
      }
    }
  }

  /**
   * get a clone of the current object
   */
  public clone(): FormModelCombine {
    // @ts-ignore
    return new this.constructor(this.id, this.fieldData["fields"], this.info);
  }

  /**
   * Returns all subfields in this combination.
   */
  getFields(): FormModel[] {
    return this.fieldData["fields"];
  }

  /**
   * @inheritDoc
   */
  getIds(): string[] {
    return this.ids;
  }
}
